import axios from "../../axios";


// const getCategories = async () => {
//   try {
//     const { data } = await axios.get(`/repairs/categories?service_type[$eq]=repair`);
//     return data;
//   } catch (e) {
//     return null;
//   }
// }

const getRepairByName = async (name, in_house) => {
  try {
    const { data } = await axios.get(`/repairs?name[$eq]=${name}&in_house=${in_house}`);
    return data?.rows?.[0];
  } catch (e) {
    return null;
  }
}

const getSpecialists = async (repair_id, in_house = true) => {
  try {
    const { data } = await axios.get(`/repairs/specialists/${repair_id}?in_house=${in_house}`);
    return data?.rows;
  } catch (e) {
    return null;
  }
};

const getRepairs = async (category, vendor_id) => {
  category = category ? `?category[$eq]=${category}` : '';
  try {
    if (vendor_id) {
      const { data } = await axios.get(`/repairs/repair_by_vendor/${vendor_id}?is_active[$eq]=true`);
      console.log(data, "data");
      return data;
    } else {
      const { data } = await axios.get(`/repairs${category}`);
      return data?.rows;
    }
  } catch (e) {
    return null;
  }
}

const findAllSpecialistsByRepair = async (repair_id, in_house) => {
  try {
    const { data } = await axios.get(`/repairs/specialists/${repair_id}?in_house=${in_house}`);
    return data;
  } catch (e) {
    return null;
  }
}

const findSpecialistsByRepair = async (repair_id, in_house) => {
  try {
    const { data } = await axios.get(`/repairs/specialist/${repair_id}?in_house=${in_house}&is_active=true`);
    return data;
  } catch (e) {
    return null;
  }
}

const getAllRepairCategories = async (tab = "categories") => {
  try {
    if (tab === "categories") {
      let { data } = await axios.get(`/repairs/repair_categories`);
      console.log(data);
      return data?.rows;
    } else {
      console.log(tab);
      const { data } = await axios.get(`/repairs/repair_by_vendors`);
      return data;
    }
    
  } catch (e) {
    return [];
  }
}


const getAllRepairsByVendors = async () => {
  try {
    const { data } = await axios.get(`/repairs/repair_by_vendors`);
    return data;
  } catch (e) {
    return null;
  }
}

export { getRepairs, findAllSpecialistsByRepair, findSpecialistsByRepair, getSpecialists, getAllRepairCategories, getAllRepairsByVendors, getRepairByName };